module.exports = __webpack_public_path__ + "static/media/icon-oportunidades-pessoas-fisicas.827865e2.svg";